/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterGroupDto } from '../../models/center-group-dto';

export interface CenterGroupControllerFindAllGroups$Params {
  centerId: string;
  query?: string;
}

export function centerGroupControllerFindAllGroups(http: HttpClient, rootUrl: string, params: CenterGroupControllerFindAllGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterGroupDto>>> {
  const rb = new RequestBuilder(rootUrl, centerGroupControllerFindAllGroups.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterGroupDto>>;
    })
  );
}

centerGroupControllerFindAllGroups.PATH = '/api/center-group';
